declare let process: { env: { [key: string]: string } };

export const devEnv = process.env.NODE_ENV === 'development';
export const FRONTEND_CONTROLLER_URL = devEnv ? import.meta.env.VITE_APP_FRONTEND_CONTROLLER_URL : '';
export const USER_SERVICE_API_URL = `${FRONTEND_CONTROLLER_URL}`;
export const CN_MGMT_API_URL = `/backEnd/noteService/api`;
export const PARTNER_MGMT_API_URL = `/backEnd/partnerService/api`;
export const ACCOUNT_RELATIONS_BACKEND_URL = `/backEnd/pcmBrBackendService`;
export const PSH_BACKEND_URL = `/backEnd/pshService/api`;
export const GRAVITY_UAT_URL = 'https://gra-fe-gravity2-uat.juliusbaer.com/gravity/';
export const GRAVITY_URL = 'https://gra-fe-gravity2.juliusbaer.com/gravity/';
export const DOCUMENT_JBG_2038_00 =
  'https://juliusbaer.navexone.eu/content/docview/?docid=22694&app=pt&source=unspecified';
export const DOCUMENT_COUNTRY_GUIDELINES =
  'https://juliusbaer.navexone.eu/content/docview/?docid=22564&app=pt&source=unspecified';
export const DOCUMENT_JBG_2048_00 =
  'https://juliusbaer.navexone.eu/content/docview/?docid=19151&app=pt&source=unspecified';
export const DOCUMENT_JBG_2082_00 =
  'https://juliusbaer.navexone.eu/content/docview/?docid=22421&app=pt&source=unspecified';
